import {Utils} from "../../../shared/utils/utils";
import {SecurityAutoupdate} from "./security-autoupdate";

export class SecurityAutoupdateMapper {

  public static map(data: any): SecurityAutoupdate {
    const securityAutoupdateData: any = data && data.general ? data.general : data;

    const securityAutoupdate: SecurityAutoupdate = new SecurityAutoupdate();

    securityAutoupdate.updateVulnerable = securityAutoupdateData ? Utils.isTruthy(securityAutoupdateData.update_vulnerable) : false;

    return securityAutoupdate;
  }

  public static generateRequestData(data: any): any {
    const securityAutoupdateData: any = {
      'name': 'general',
      'settings': {
        'update_vulnerable': data ? '1' : '0',
      }
    };

    return securityAutoupdateData;
  }

  public static mapResponseData(data: any): any {
    const securityAutoupdateData: any = {
      'general': {
        'update_vulnerable': data ? '1' : '0'
      }
    };

    return securityAutoupdateData;
  }

}
